import * as React from "react";
import { Navigate } from "react-router-dom";
import { CircularIndeterminate } from "../../pages/components/Progress";

import useAuth from "../../hooks/useAuth";
import { checkPermissions } from "../../utils/checkPermissions";

// For routes that can only be accessed by authenticated users
function AuthGuard({
  children,
  requiredPermissions = [],
  disabledChecks: { auth: disabledAuth, select: disabledSelect } = {},
}) {
  const { isAuthenticated, isInitialized, permissions, app } = useAuth();

  if (!isInitialized) {
    return <CircularIndeterminate />;
  }

  if (!isAuthenticated && !disabledAuth) {
    return <Navigate to="/auth/sign-in" />;
  }

  if (app === null && !disabledSelect) {
    return <Navigate to="/auth/select" />;
  }

  if (checkPermissions(requiredPermissions, permissions)) {
    return <React.Fragment>{children}</React.Fragment>;
  }

  return <Navigate to="/profile" />;
}

export default AuthGuard;
